import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Firebase } from './api'
import { FirebaseContext } from './context'



ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById('root')
);